import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { AngularFirestore } from 'angularfire2/firestore';
import { UserService } from '../../providers/session-service/user-service';

@Component({
  selector: 'page-notifications',
  templateUrl: 'notifications.html',
})
export class NotificationsPage {

  user: any;
  notifications: any[];

  constructor(public navCtrl: NavController, public navParams: NavParams, public db: AngularFirestore, public userService: UserService) {
    this.notifications = [];
    this.user = this.userService.getUser();
  }

  ionViewDidLoad() {
    let nowDate = Date.now();
    this.user.numberOfUnreadNotifications = 0;
    this.db.doc('users/' + this.user.id).update(this.user);

    this.db.collection('users/' + this.user.id + '/notifications').valueChanges().subscribe((notifications: any) => {
      this.notifications = [];
      notifications.forEach(notification => {
        let notificationVisibleFrom = + new Date(notification.visibleFrom);
        if (nowDate >= notificationVisibleFrom) {
          this.notifications.push(notification);
        }
      });

      this.notifications.sort((a, b) => {
        const d1 = + new Date(a.visibleFrom);
        const d2 = + new Date(b.visibleFrom);
        return d1 > d2 ? -1 : 1;
      });
    });
  }

}



// WEBPACK FOOTER //
// ./src/pages/notifications/notifications.ts